import { useNavigate } from 'react-router-dom';

import { ia } from 'lib/helpers/utility';

import Button from 'components/shared/Buttons/Button';
import Popover from 'components/shared/Popovers/Popover/Popover';

import { sendLink } from '../lib/helper';

const HeaderActions = ({ selectedRows, setSelectedRows, gridApi }) => {
  const navigate = useNavigate();

  const clearSelectedRows = () => {
    setSelectedRows([]);
    if (gridApi) gridApi.deselectAll();
  };

  const options = [
    {
      label: 'Email',
      icon: 'mail-mono',
      onClick: () =>
        sendLink({
          type: 'email',
          navigate,
          packets: selectedRows,
          setSelectedRows: clearSelectedRows
        })
    },
    {
      label: 'Text Message',
      icon: 'editor-text-mono',
      onClick: () =>
        sendLink({
          type: 'text',
          navigate,
          packets: selectedRows,
          setSelectedRows: clearSelectedRows
        })
    }
  ];

  if (!ia(selectedRows)) return null;

  return (
    <Popover
      className="flex flex-1 justify-center self-center"
      buttonClassName="!bg-primary-700"
      position="left"
      isFixed
      isBorder={false}
      options={options}
      customButtonTrigger={
        <Button text="Resend Link" icon="calendar-tick-mono" className="whitespace-nowrap" />
      }
    />
  );
};

export default HeaderActions;
